import React from 'react';

interface ISvgIcon {
  color?: string;
}

const ShareVehicle = ({color = "#0000FF"} : ISvgIcon) => {
  return (
    <svg id="Group_870" data-name="Group 870" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="13.397" height="16" viewBox="0 0 13.397 16">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_2153" data-name="Rectangle 2153" width="13.397" height="16" fill={color} stroke={color} strokeWidth="0.3"/>
        </clipPath>
      </defs>
      <g id="Group_871" data-name="Group 871" clipPath="url(#clip-path)">
        <path id="Path_3651" data-name="Path 3651" d="M10.978,11.163a2.42,2.42,0,0,0-2.052,1.145L4.361,9.436a2.4,2.4,0,0,0,0-2.872L8.926,3.692A2.417,2.417,0,1,0,10.978,0h0A2.417,2.417,0,0,0,8.751,3.36L4.117,6.279a2.419,2.419,0,1,0,0,3.442L8.751,12.64a2.418,2.418,0,1,0,2.227-1.477m0-10.791A2.047,2.047,0,1,1,8.931,2.419,2.044,2.044,0,0,1,10.978.372M2.419,10.046A2.047,2.047,0,1,1,4.466,8a2.044,2.044,0,0,1-2.047,2.047m8.559,5.581a2.047,2.047,0,1,1,2.047-2.047,2.044,2.044,0,0,1-2.047,2.047" fill={color} stroke={color} strokeWidth="0.3"/>
      </g>
    </svg>
  )
}

export default ShareVehicle;